import React from 'react'
import { useHistory } from 'react-router'
import { Edit2, Colorfilter, ProfileDelete } from 'iconsax-react'

import MediaAvatar from '../../../atoms/MediaAvatar'
import MoreHorizontalIcon from '../../../icons/MoreHorizontalIcon'
import ButtonMenu from '../../../molecules/ButtonMenu2'
import OverflowText from '../../../atoms/OverflowText'
import ConversationParticipants from '../../../molecules/ConversationParticipants'

import { Routes } from '../../../../Routes'
import { useAgent } from '../../../../providers/AgentProvider'
import useStyles from './styles'

const EditIcon = React.memo(() => (
  <Edit2 size='16' color='#8F8F8F' variant='Bold' style={{ marginRight: 8 }} />
))
const MergeIcon = React.memo(() => (
  <Colorfilter
    size='16'
    color='#8F8F8F'
    variant='Bold'
    style={{ marginRight: 8 }}
  />
))
const BlockIcon = React.memo(() => (
  <ProfileDelete
    size='16'
    color='#8F8F8F'
    variant='Bold'
    style={{ marginRight: 8 }}
  />
))

const Profile = ({
  conversation,
  allUsers,
  owner,
  hasOwner,
  openMergeModal
}) => {
  const history = useHistory()

  const { currentUser } = useAgent()

  const userIDs = React.useMemo(
    () =>
      conversation?.users
        ? conversation?.users.filter(id => id !== currentUser()?.id)
        : [],
    [conversation?.users, currentUser]
  )

  const multiUser = userIDs.length >= 2
  const classes = useStyles({ multiUser })

  const options = React.useMemo(() => {
    return [
      {
        name: 'Edit Contact',
        Icon: EditIcon
      },
      {
        name: 'Merge Contact',
        Icon: MergeIcon
      },
      {
        name: 'Block User',
        Icon: BlockIcon,
        disabled: true
      }
    ]
  }, [])

  const name = React.useMemo(() => {
    if (hasOwner) {
      const user = allUsers[owner?.id]
      if (user && user.name !== owner?.name) return user.name

      return owner?.name || 'Loading...'
    }

    return '<NO OWNER>'
  }, [hasOwner, owner, allUsers])

  const avatar = React.useMemo(
    () => (
      <div className={classes.avatar}>
        <MediaAvatar
          user={hasOwner ? owner : null}
          hideCard={false}
          group
          showBadge
          className='avatar'
        />
      </div>
    ),
    [classes.avatar, hasOwner, owner]
  )

  const handleSelect = React.useCallback(
    val => {
      if (val === 'Edit Contact') {
        const { id, type } = owner
        const isExternal = type.external
        history.push(`${isExternal ? Routes.CUSTOMERS : Routes.USERS}/${id}`)
      } else if (val === 'Merge Contact') {
        openMergeModal()
      }
    },
    [history, owner, openMergeModal]
  )

  if (!conversation) {
    return <div className={classes.root}></div>
  }

  return (
    <div className={classes.root}>
      {avatar}

      <div className={classes.nameRoot}>
        <OverflowText className={classes.name}>{name}</OverflowText>

        {multiUser && (
          <ConversationParticipants
            participants={userIDs}
            fullParticipants={conversation.fullUsers}
          />
        )}
      </div>

      <span className={classes.menuRoot}>
        {/* @ts-ignore */}
        <ButtonMenu options={options} onSelect={handleSelect}>
          <MoreHorizontalIcon />
        </ButtonMenu>
      </span>
    </div>
  )
}

export default Profile
